import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Footnote1, Title3 } from '@sbol/nova';
import { Button } from '../../lib/ui/Button';
import AlienShipImg from './img/alien_ship.svg?react';
import styles from './ErrorView.module.scss';

export const UnknownErrorView: FC = observer(() => (
  <div className={styles.ErrorView}>
    <AlienShipImg />
    <Title3 className={styles.Title}>Что-то пошло не так</Title3>
    <Footnote1 color="secondary" className={styles.Subtitle}>
      Пожалуйста, обновите страницу или попробуйте позже
    </Footnote1>
    <Button className={styles.Button} text="Обновить страницу" onClick={() => location.reload()} />
  </div>
));
